import React from 'react';
import '../../FormBuilder.css';

const YesOrNoQuestionsElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'yes/noQuestions' && (
        <label className='titleTextLbl'>
            {component.fieldName || "Yes/No Questions"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default YesOrNoQuestionsElement;
